import { yupResolver } from '@hookform/resolvers/yup'
import { UOMContract } from 'models'
import { useForm, useFormContext } from 'react-hook-form'
import { Dictionary } from 'utilities/typeUtility/typeUtility'
import * as yup from 'yup'

const useNewUOMForm = (
    defaultUOM: UOMContract,
    duplicatedUOMNames: string[],
    duplciatedUOMSymbols: Dictionary<string[]>,
) => {
    const validate = yup.object().shape({
        name: yup
            .string()
            .required()
            .test(
                'name-duplicate',
                'uoms.message.error.name_duplicated',
                (val) => {
                    return !duplicatedUOMNames.some(
                        (s) =>
                            s.toLowerCase().trim() ===
                            (val ?? '').toLowerCase().trim(),
                    )
                },
            ),
        uomClassID: yup
            .number()
            .required('uoms.message.error.uom_category_required'),
        symbol: yup
            .string()
            .required()
            .test(
                'symbol-duplicate',
                'uoms.message.error.symbol_duplicated',
                (val, data) => {
                    // For symbol, `M` and `m` are different
                    var classID = data.parent.uomClassID
                    if (classID) {
                        var duplciatedUOMSymbolsInSameClass =
                            duplciatedUOMSymbols[classID]
                        return !duplciatedUOMSymbolsInSameClass.some(
                            (s) => s.trim() === (val ?? '').trim(),
                        )
                    }
                    // ignore if UOM class id is null | undefined
                    return true
                },
            ),
        initialUnitForConversion: yup.number().when('enableConversion', {
            is: true,
            then: yup.number().moreThan(0),
        }),
        conversion: yup.number().when('enableConversion', {
            is: true,
            then: yup.number().moreThan(0),
        }),
        referenceUOMID: yup.number().when('enableConversion', {
            is: true,
            then: yup.number().required('uoms.message.error.ref_uom_required'),
        }),
    })

    const form = useForm<UOMContract>({
        defaultValues: defaultUOM,
        resolver: yupResolver(validate),
    })

    return form
}

export default useNewUOMForm

export const useNewUOMFormContext = () => useFormContext<UOMContract>()
